import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BaseLink from '@/components_new/BaseLink.vue'
import Logo from '@/components_new/Logo/Logo.vue'
import Typography from '@/components_new/Typography.vue'
import { useConfig } from '@/composables/config'


export default /*@__PURE__*/_defineComponent({
  __name: 'StickyWidgetBanner',
  setup(__props) {

const { VUE_APP_HOST_URL } = useConfig()
const logoLink = `${VUE_APP_HOST_URL}?from=widget` // TODO keep clid?

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.sticky_banner)
  }, [
    _createVNode(BaseLink, {
      target: "_blank",
      externalTo: logoLink
    }, {
      default: _withCtx(() => [
        _createVNode(Typography, {
          is: "div",
          type: "caption",
          size: "s",
          class: _normalizeClass(_ctx.$style.logoContainer)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tr('widgetGame.powered_by')) + " ", 1),
            _createVNode(Logo, {
              class: _normalizeClass(_ctx.$style.logo_override),
              mode: "full",
              noLink: ""
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ], 2))
}
}

})